import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-hub-logo-loader',
    templateUrl: './hub-logo-loader.component.html',
    styleUrls: ['./hub-logo-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubLogoLoaderComponent {
    @Input() public text = '';
    @Input() public optionalClass = '';
    @Input() classText: string = 'text-dark font-weight-bold';
}
